/**
 * Operator Client
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const PlatePosition = {
    Front: 'Front',
    Rear: 'Rear',
    Left: 'Left',
    Right: 'Right'
} as const;
export type PlatePosition = typeof PlatePosition[keyof typeof PlatePosition];

